import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function useScrollToAnchor() {
  const location = useLocation()

  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      // Wait for the DOM to be ready
      setTimeout(() => {
        const element = document.querySelector(location.hash)
        if (element) {
          // Smooth scroll to the element
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          })
        }
      }, 100) // Small delay to ensure content is rendered
    }
  }, [location.hash])
}

